import { useEffect, useState } from "react";

import { Colors } from "@blueprintjs/core";
import styled from "@emotion/styled";
import { useNavigate } from "react-router";

import { useIsTestWorkspace } from "@/components/helpers/custom-hooks/use-workspace";
import { Box, Flex } from "@/components/layout/flexbox";
import { Media } from "@/components/layout/Media";
import { Container } from "@/components/pieces/bootstrap";
import { PracticeSvg } from "@/components/pieces/icons/svg/practice";
import { Tabs } from "@/components/pieces/Tabs";
import { BRAND_PURPLE, HEADING_FONT, SUBTEXT_COLOR } from "@/css/constants";
import { Tab } from "@/types/tabs";

const ROLEPLAY_TABS_CONFIG = [
  {
    key: "/roleplays",
    label: "Practice",
  },
  {
    key: "/roleplays/assignments",
    label: "Assignments",
  },
];

export function RoleplaysHeader({ showSubTitle = true }) {
  const [selectedTab, setSelectedTab] = useState<Tab>(ROLEPLAY_TABS_CONFIG[0]);
  const navigate = useNavigate();
  useEffect(() => {
    const path = window.location.pathname;
    const tab = ROLEPLAY_TABS_CONFIG.find((tab) => tab.key === path);
    if (tab) {
      setSelectedTab(tab);
    }
  }, []);

  const isTestWorkspace = useIsTestWorkspace();
  return (
    <Media greaterThan="xs">
      <Box width={1} className="bbs" pt={4} bg={Colors.WHITE}>
        <Container>
          <Flex alignItems="flex-end">
            <Box css={{ flex: 1 }}>
              <Flex alignItems="center">
                <PracticeSvg size={26} color={BRAND_PURPLE} />
                <Box ml={3} fontFamily={HEADING_FONT}>
                  <Heading>Roleplays</Heading>
                </Box>
              </Flex>
              {showSubTitle && (
                <Box color={SUBTEXT_COLOR} mt={2}>
                  Practice and improve your communication skills through
                  AI-powered scenarios
                </Box>
              )}
            </Box>
          </Flex>
          {isTestWorkspace ? (
            <Tabs
              tabs={ROLEPLAY_TABS_CONFIG.map((tab) => ({
                key: tab.key,
                label: tab.label,
                value: tab.key,
              }))}
              tab={selectedTab}
              onTabChange={(tab) => {
                setSelectedTab(tab);
                navigate(tab.key);
              }}
              style={{
                borderTop: "none",
                boxShadow: "none",
              }}
              backgroundColor="transparent"
            />
          ) : (
            <div className="mb-8" />
          )}
        </Container>
      </Box>
    </Media>
  );
}

const Heading = styled("h1")`
  font-size: 28px;
  margin: 0;
`;
